module.exports = __webpack_public_path__ + "static/media/YM78_2.de756f07.jpg";